<template>
    <div>
      <div class="container-fluid">
        <div class="row full-height">
            <div class="card mt-4 pt-3 px-3 h-100 full-page-card">
                <h2 class="card-title">Create Volunteer (User)</h2>
                <div class="row cols full-page-card__content">
                    <div class="col-md-8">
                            <div class="alert alert-success" role="alert" v-if="is_success">
                                Volunteer (user) created successfully!
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="is_error">
                                {{ this.error_message }}
                            </div>
                        <h4 style="color:chocolate">User (Volunteer)</h4>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="First Name" placeholder="First Name" v-model="user.firstName"></base-input>
                                <div v-if="errorFlags.firstName" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please enter user first name.</div>
                            </div>
                            <div class="col-md-6">
                                <base-input type="text" label="Last Name" placeholder="Last Name" v-model="user.lastName"></base-input>
                                <div v-if="errorFlags.lastName" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please enter user lastname.</div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="date" label="Date of Birth" placeholder="Date of Birth" v-model="user.dateOfBirth"></base-input>
                                <div v-if="errorFlags.dateOfBirth" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select user date of birth.</div>

                            </div>
                            <div class="col-md-6">
                                <base-input type="email" label="Email" placeholder="Email" v-model="user.email"></base-input>
                                <div v-if="errorFlags.email" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please enter a valid email.</div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="Mobile" placeholder="07-" v-model="user.phoneNumber"></base-input>
                                <div v-if="errorFlags.phoneNumber" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please enter user's phone number .</div>

                            </div>
                        </div>

                        <h4 style="color:chocolate">Charity</h4>

                        <div class="row">
                            <div class="col-md-6">
                                <base-input label="Charity">
                                    <select
                                        v-model="charityId"
                                        class="form-control select--yes-no"
                                        @change="popolateCharityBranches(charityId)"
                                    >
                                        <option value="" disabled selected>Select Charity</option>
                                        <option
                                            v-for="(option, index) in charities"
                                            :value="option.id"
                                            >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <div v-if="errorFlags.charityId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select a charity.</div>
                                </base-input>

                            </div>
                            <div class="col-md-6">
                                <base-input label="Charity's Branch">
                                    <select
                                            v-model="charityBranchId"
                                            class="form-control select--yes-no"
                                            v-on:change="onChangeCharityBranch($event)"
                                        >
                                            <option value="" disabled selected>Select Charity's Branch</option>
                                            <option
                                                v-for="(option, index) in charityBranches"
                                                :value="option.id"
                                                >
                                                {{ option.name }}
                                            </option>
                                    </select>
                                    <div v-if="errorFlags.charityBranchId" id="submit-error" class="has-text-danger" style="color:red; font-size: small;">Please select charity's branch.</div>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">

                            </div>

                            <div class="col-md-4">
                                <div class="col-header" style="justify-content: flex-end;">
                                    <button @click="createVolunteer" class="btn btn-success">Save</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import CharityLeadsService from '@/services/CharityLeadsService.js';
    import StatsService from '@/services/StatsService.js';
    import UsersService from '@/services/UsersService.js';

    export default {
        name: 'CreateDrop',
        data() {
            return {
                charities: [],
                charityBranches: [],
                charityId: "",
                charityBranchId: "",
                user: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phoneNumber: "",
                    dateOfBirth: "",
                },
                errorFlags: {
                    charityId: false,
                    charityBranchId: false,
                    firstName: false,
                    lastName: false,
                    email: false,
                    phoneNumber: false,
                    dateOfBirth: false,
                },
                    submit_error: ``,
                    search_button_class: ``,
                    is_success: false,
                    is_error : false,
                    error_message: ``,
            };
        },

        mounted() {
            this.loadCharities();
        },

        methods: {
            clearErrors: function() {
                for(var key in this.errorFlags) {
                    if(this.errorFlags.hasOwnProperty(key)) {
                        this.errorFlags[key] = false;
                    }
                }
                this.submit_error = '';
            },

            validateData: function() {
                this.clearErrors();
                
                var isError = false;
                
                if(!this.charityId || this.charityId <= 0) {
                    this.errorFlags.charityId = true;
                    isError = true;
                }

                if(!this.charityBranchId || this.charityBranchId <= 0) {
                    this.errorFlags.charityBranchId = true;
                    isError = true;
                }

                if(!this.user.firstName || this.user.firstName <= 0) {
                    this.errorFlags.firstName = true;
                    isError = true;
                }

                if(!this.user.lastName || this.user.lastName <= 0) {
                    this.errorFlags.lastName = true;
                    isError = true;
                }

                if(!this.user.email || this.user.email <= 0) {
                    this.errorFlags.email = true;
                    isError = true;
                }

                if(!this.user.dateOfBirth || this.user.dateOfBirth <= 0) {
                    this.errorFlags.dateOfBirth = true;
                    isError = true;
                }

                if(!this.user.phoneNumber || this.user.phoneNumber <= 0) {
                    this.errorFlags.phoneNumber = true;
                    isError = true;
                }

                return !isError;
            },
            
            async loadCharities() {
                let res = await CharityLeadsService.getAll();
                this.charities = res.data;
            },

            async popolateCharityBranches(charityId) {
                let res = await StatsService.getCharityLeadStats(charityId);
                this.charityBranches = res.data.myBranches;
            },

            async onChangeCharityBranch(e) {
                // let id = e.target.value;
                this.selectedCharityName = e.target.options[e.target.options.selectedIndex].text;
            },

            async createVolunteer(){
                if(!this.validateData()) {
                    this.submit_error = 'Please correct all errors to proceed.';
                    return;
                }

                let formData = {
                    ...this.user,
                    charityId: this.charityId,
                    charityBranchId: this.charityBranchId,
                }

                // call create user slackbot endpoint
                let userData = {
                    "email": formData.email,
                    "mobile": this.formatPhone(formData.phoneNumber),
                    "resetPasswordVerificationCode": null,
                    "resetPasswordVerificationCodeExpiresAt": null,
                    "verified": true,
                    "firstName": formData.firstName.trim(),
                    "lastName": formData.lastName.trim(),
                    "dateOfBirth":formData.dateOfBirth,
                    "group": "volunteers",
                    "groupEntityId": formData.charityBranchId,
                    "contactTelephone": null,
                    "position": null,
                    "acceptCheckbox1": true,
                    "acceptCheckbox2": null,
                    "acceptTermsAndConditions": true,
                    "suspended": false
                };

                try {
                   
                    await UsersService.validateField({"mobile" : formData.phoneNumber});

                } catch (error) {

                        this.is_error = true;
                    
                        if(error.response.status === 409) {

                            this.error_message = 'Mobile number already exists...';

                            return;
                        }

                        this.error_message = 'Oops! Something went wrong while validating mobile number.';
                }

                try {
                    this.is_error = false;
                   
                    let userRes = await UsersService.createOne(userData);

                    this.resetFormFields();

                    this.is_success = true;

                    UsersService.updateSlack(`*User Created Succesfully* (userId: ${userRes.data.id}, source: Web). Summary:\n\n📝 *First Name:* ${userRes.data.firstName}\n📝 *Last Name:* ${userRes.data.lastName}\n📅 *Date of Birth:* ${userRes.data.dateOfBirth}\n📩 *Email:* ${userRes.data.email}\n☎️ *Mobile:* ${userRes.data.mobile}\n🏡 *Associated Charity:* ${this.selectedCharityName}`)
                    
                } catch (error) {

                    this.is_error = true;
                    
                    if(error.response.status === 409) {
                        this.error_message = 'That email address is already in use, please try another...';
                        
                        return;
                    }

                    this.error_message = 'Oops! Something went wrong, please try again...';
                }
            },

            resetFormFields() {
                Object.keys(this.user).forEach(key => {
                  delete this.user[key];
                });

                this.charityId = "";

                this.charityBranchId = "";
            },

            formatPhone(phone) {
                const UK_CODE = "+44";
                return phone.includes(UK_CODE) ? phone : UK_CODE + phone.substring(1)
            }
        },
    };
  </script>
  
  
  <style lang="scss" scoped>
    
  </style>
  